<template>
	<path
		id="Vector"
		d="M13.5 7H12.75V4.75C12.75 2.13125 10.6187 0 8 0C5.38125 0 3.25 2.13125 3.25 4.75V7H2.5C1.67188 7 1 7.67188 1 8.5V14.5C1 15.3281 1.67188 16 2.5 16H13.5C14.3281 16 15 15.3281 15 14.5V8.5C15 7.67188 14.3281 7 13.5 7ZM10.25 7H5.75V4.75C5.75 3.50938 6.75938 2.5 8 2.5C9.24063 2.5 10.25 3.50938 10.25 4.75V7Z"
		fill="#E2E2E2"
	/>
</template>
